import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
// import { api } from '../context/AuthContext';
import api from '../api';

const ExpenseForm = ({ isEdit }) => {
  const [formData, setFormData] = useState({
    category: 'utilities',
    amount: '',
    date: new Date().toISOString().split('T')[0],
    name: ''
  });

  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    if (isEdit && id) {
      const fetchExpense = async () => {
        try {
          const res = await api.get(`/expenses/${id}`);
          const { amount, category, expenseDate, name } = res.data;

          setFormData({
            category: category || 'utilities',
            amount: amount?.toString() || '',
            date: new Date(expenseDate).toISOString().split('T')[0],
            name: name || ''
          });
        } catch (err) {
          console.error('Error fetching expense:', err);
          setError(err.response?.data?.message || 'Error fetching expense');
        }
      };
      fetchExpense();
    }
  }, [id, isEdit]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleCategoryChange = (e) => {
    const newCategory = e.target.value;
    setFormData(prev => ({
      ...prev,
      category: newCategory,
      name: newCategory === 'others' ? prev.name : ''
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Frontend validation
    if (formData.category === 'others' && !formData.name.trim()) {
      return setError('Please enter a name for the expense');
    }

    if (!formData.amount || !formData.category || !formData.date) {
      return setError('Please fill in all required fields.');
    }

    try {
      const payload = {
        ...formData,
        amount: parseFloat(formData.amount),
        // Only send name if category is others
        name: formData.category === 'others' ? formData.name : undefined
      };

      if (isEdit) {
        await api.put(`/expenses/${id}`, payload);
      } else {
        await api.post('/expenses', payload);
      }
      navigate('/expenses');
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'Error saving expense.');
    }
  };

  return (
    <Container className="my-4">
      <Card>
        <Card.Body>
          <Card.Title className="text-center mb-4">
            {isEdit ? 'Edit Expense' : 'Add New Expense'}
          </Card.Title>

          {error && <Alert variant="danger">{error}</Alert>}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Category</Form.Label>
              <Form.Select
                name="category"
                value={formData.category}
                onChange={handleCategoryChange}
                required
              >
                <option value="utilities">Utilities</option>
                <option value="salary">Salary</option>
                <option value="maintenance">Maintenance</option>
                <option value="taxes">Taxes</option>
                <option value="supplies">Supplies</option>
                <option value="rent">Rent</option>
                <option value="advertising">Advertising</option>
                <option value="cost">Cost of Goods</option>
                <option value="others">Others</option>
              </Form.Select>
            </Form.Group>

            {formData.category === 'others' && (
              <Form.Group className="mb-3">
                <Form.Label>Expense Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  placeholder="e.g., Lunch, Office Party"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  maxLength={50}
                />
                <Form.Text className="text-muted">
                  Please specify the expense name
                </Form.Text>
              </Form.Group>
            )}

            <Form.Group className="mb-3">
              <Form.Label>Amount (Ksh)</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                min="0.01"
                name="amount"
                placeholder="Enter amount"
                value={formData.amount}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Date</Form.Label>
              <Form.Control
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <div className="d-grid gap-2">
              <Button variant="primary" type="submit" size="lg">
                {isEdit ? 'Update Expense' : 'Add Expense'}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ExpenseForm;